// src/capabilities/featureKeys.js

export const FK = {
  DASHBOARD_VIEW: "DASHBOARD.VIEW",
  DASHBOARD_INBOX_ANALYTICS_VIEW: "DASHBOARD.INBOX.ANALYTICS.VIEW",
  DASHBOARD_LEAD_COMMAND_CENTRE_VIEW:
    "DASHBOARD.LEAD_COMMAND_CENTRE.VIEW",
  DASHBOARD_LEAD_COMMAND_CENTRE_CONFIGURE_FILTERS:
    "DASHBOARD.LEAD_COMMAND_CENTRE.CONFIGURE_FILTERS",

  CRM_WORKSPACE_VIEW: "CRM.WORKSPACE.VIEW",
  CRM_CONTACT_VIEW: "CRM.CONTACT.VIEW",
  CRM_CONTACT_DETAIL_VIEW: "CRM.CONTACT.DETAIL.VIEW",
  CRM_LEADS_WORKBENCH_VIEW: "CRM.LEADS.WORKBENCH.VIEW",
  CRM_MY_WORK_VIEW: "CRM.MY_WORK.VIEW",
  CRM_MY_WORK_CREATE: "CRM.MY_WORK.CREATE",
  CRM_MY_WORK_EDIT: "CRM.MY_WORK.EDIT",
  CRM_MY_WORK_DELETE: "CRM.MY_WORK.DELETE",
  CRM_MY_WORK_SCHEDULE_WHATSAPP: "CRM.MY_WORK.SCHEDULE_WHATSAPP",
  CRM_MY_WORK_ASSIGN: "CRM.MY_WORK.ASSIGN",
  CRM_MY_WORK_MANAGE_TEAM: "CRM.MY_WORK.MANAGE_TEAM",
  CRM_TAGS_VIEW: "CRM.TAGS.VIEW",
  CRM_REMINDERS_VIEW: "CRM.REMINDERS.VIEW",
  CRM_FOLLOW_UP_PRESETS_VIEW: "CRM.MY_WORK.VIEW",
  CRM_MESSAGE_PRESETS_VIEW: "CRM.MESSAGE_PRESETS.VIEW",
  CRM_MESSAGE_PRESETS_MANAGE: "CRM.MESSAGE_PRESETS.MANAGE",
  CRM_TIMELINE_VIEW: "CRM.TIMELINE.VIEW",
  CRM_CONTACT_TIMELINE_VIEW: "CRM.CONTACT.TIMELINE.VIEW",
  CRM_ATTRIBUTE_VIEW: "CRM.ATTRIBUTE.VIEW",
  CRM_NOTES_VIEW: "CRM.NOTES.VIEW",
  CRM_CONTACT_NOTES_VIEW: "CRM.CONTACT.NOTES.VIEW",
  CRM_TAGS_EDIT: "CRM.TAGS.VIEW",
  CRM_LEAD_AUTOMATION_RULES_VIEW: "CRM.LEAD_AUTOMATION_RULES.VIEW",
  CRM_LEAD_AUTOMATION_RULES_CREATE: "CRM.LEAD_AUTOMATION_RULES.CREATE",
  CRM_LEAD_AUTOMATION_RULES_UPDATE: "CRM.LEAD_AUTOMATION_RULES.UPDATE",
  CRM_LEAD_AUTOMATION_RULES_DELETE: "CRM.LEAD_AUTOMATION_RULES.DELETE",
  CRM_LEAD_AUTOMATION_RULES_EVALUATE: "CRM.LEAD_AUTOMATION_RULES.EVALUATE",
  CRM_NOTIFICATION_RECIPIENTS_VIEW: "CRM.NOTIFICATION_RECIPIENTS.VIEW",
  CRM_NOTIFICATION_RECIPIENTS_CREATE: "CRM.NOTIFICATION_RECIPIENTS.CREATE",
  CRM_NOTIFICATION_RECIPIENTS_UPDATE: "CRM.NOTIFICATION_RECIPIENTS.UPDATE",
  CRM_NOTIFICATION_RECIPIENTS_DELETE: "CRM.NOTIFICATION_RECIPIENTS.DELETE",

  CATALOG_WORKSPACE_VIEW: "CATALOG.WORKSPACE.VIEW",
  CATALOG_VIEW: "CATALOG.VIEW",
  CATALOG_CREATE: "CATALOG.CREATE",
  CATALOG_DELETE: "CATALOG.DELETE",
  CATALOG_AUTOMATION: "CATALOG.AUTOMATION",
  COMMERCE_TRANSACTION_VIEW: "COMMERCE.TRANSACTION.VIEW",
  COMMERCE_TRANSACTION_STATUS_EDIT: "COMMERCE.TRANSACTION.STATUS_EDIT",
  COMMERCE_ORDER_PRICING_UPDATE: "COMMERCE.ORDER_PRICING.UPDATE",
  COMMERCE_PAYMENT_VIEW: "COMMERCE.PAYMENT.VIEW",
  COMMERCE_PAYMENT_REQUEST: "COMMERCE.PAYMENT.REQUEST",
  COMMERCE_PAYMENT_CONFIGURE: "COMMERCE.PAYMENT.CONFIGURE",
  SCHEDULING_VIEW: "SCHEDULING.VIEW",
  SCHEDULING_MANAGE: "SCHEDULING.MANAGE",

  CAMPAIGN_WORKSPACE_VIEW: "CAMPAIGN.WORKSPACE.VIEW",
  CAMPAIGN_BUILDER: "CAMPAIGN.BUILDER",
  CAMPAIGN_LIST_VIEW: "CAMPAIGN.LIST.VIEW",
  CAMPAIGN_STATUS_VIEW: "CAMPAIGN.STATUS.VIEW",
  CAMPAIGN_CTA_MANAGEMENT: "CAMPAIGN.CTA.MANAGEMENT",
  CAMPAIGN_IMAGE_DETAIL_VIEW: "CAMPAIGN.IMAGE.DETAIL.VIEW",
  CAMPAIGN_IMAGE_EDIT: "CAMPAIGN.IMAGE.EDIT",
  CAMPAIGN_ASSIGN_CONTACTS: "CAMPAIGN.ASSIGN.CONTACTS",
  CAMPAIGN_ASSIGNED_CONTACTS_VIEW: "CAMPAIGN.ASSIGNED.CONTACTS.VIEW",
  CAMPAIGN_DETAIL_LOGS_VIEW: "CAMPAIGN.DETAIL.LOGS.VIEW",
  CAMPAIGN_MESSAGE_LOGS_VIEW: "CAMPAIGN.MESSAGE.LOGS.VIEW",
  CAMPAIGN_PROGRESS_VIEW: "CAMPAIGN.PROGRESS.VIEW",
  CAMPAIGN_REPORT_LOGS_VIEW: "CAMPAIGN.REPORT.LOGS.VIEW",
  CAMPAIGN_REPORT_BUCKET_VIEW: "CAMPAIGN.REPORT.BUCKET.VIEW",
  CAMPAIGN_REPORT_RETARGET_VIEW: "CAMPAIGN.REPORT.RETARGET.VIEW",

  MESSAGING_WORKSPACE_VIEW: "MESSAGING.WORKSPACE.VIEW",
  MESSAGING_SEND_TEXT: "MESSAGING.SEND.TEXT",
  MESSAGING_SEND_TEMPLATE: "MESSAGING.SEND.TEMPLATE",
  MESSAGING_REPORT_VIEW: "MESSAGING.REPORT.VIEW",

  AUTOMATION_WORKSPACE_VIEW: "AUTOMATION.WORKSPACE.VIEW",
  AUTOMATION_CREATE_BOT: "AUTOMATION.CREATE.BOT",
  AUTOMATION_AUTOREPLY_LOGS_VIEW: "AUTOMATION.AUTOREPLY.LOGS.VIEW",
  AUTOMATION_AUTOREPLY_TEST_CONSOLE: "AUTOMATION.AUTOREPLY.TEST.CONSOLE",
  AUTOMATION_RULES_VIEW: "AUTOMATION.RULES.VIEW",
  AUTOMATION_VIEW_FLOW_MANAGE: "AUTOMATION.VIEW.FLOW.MANAGE",
  AUTOMATION_VIEW_FLOW_ANALYTICS: "AUTOMATION.VIEW.FLOW.ANALYTICS",
  AUTOMATION_CREATE_TEMPLATE_FLOW: "AUTOMATION.CREATE.TEMPLATE.FLOW",
  AUTOMATION_TRIGGER_TEST: "AUTOMATION.TRIGGER.TEST",
  AUTOMATION_SCHEDULED_MESSAGES_VIEW: "AUTOMATION.SCHEDULED_MESSAGES.VIEW",
  AUTOMATION_SCHEDULED_MESSAGES_CREATE: "AUTOMATION.SCHEDULED_MESSAGES.CREATE",
  AUTOMATION_SCHEDULED_MESSAGES_RESCHEDULE: "AUTOMATION.SCHEDULED_MESSAGES.RESCHEDULE",
  AUTOMATION_SCHEDULED_MESSAGES_CANCEL: "AUTOMATION.SCHEDULED_MESSAGES.CANCEL",
  WHATSAPP_FLOW_VIEW: "WHATSAPP_FLOW.VIEW",
  WHATSAPP_FLOW_CREATE: "WHATSAPP_FLOW.CREATE",
  WHATSAPP_FLOW_EDIT: "WHATSAPP_FLOW.EDIT",
  WHATSAPP_FLOW_PUBLISH: "WHATSAPP_FLOW.PUBLISH",
  WHATSAPP_FLOW_ARCHIVE: "WHATSAPP_FLOW.ARCHIVE",
  AI_AGENT_ENABLED: "AI.AGENT.ENABLED",
  AI_AGENT_WORKSPACE_VIEW: "AI.AGENT.WORKSPACE.VIEW",
  AI_REPLY_DRAFT: "AI.REPLY.DRAFT",
  AI_AGENT_SETTINGS_VIEW: "AI.AGENT.SETTINGS.VIEW",
  AI_AGENT_SETTINGS_MANAGE: "AI.AGENT.SETTINGS.MANAGE",
  AI_AGENT_USAGE_VIEW: "AI.AGENT.USAGE.VIEW",
  AI_KNOWLEDGE_VIEW: "AI.KNOWLEDGE.VIEW",
  AI_KNOWLEDGE_MANAGE: "AI.KNOWLEDGE.MANAGE",
  AI_MEDIA_ASSETS_VIEW: "AI.MEDIA_ASSETS.VIEW",
  AI_MEDIA_ASSETS_MANAGE: "AI.MEDIA_ASSETS.MANAGE",
  AI_TEST_CONSOLE_USE: "AI.TEST_CONSOLE.USE",
  AI_FALLBACK_DRY_RUN: "AI.FALLBACK.DRY_RUN",
  AI_AUTO_REPLY: "AI.AUTO_REPLY",
  AI_AUTO_REPLY_MANAGE: "AI.AUTO_REPLY.MANAGE",

  INBOX_WORKSPACE_VIEW: "INBOX.WORKSPACE.VIEW",
  INBOX_VIEW: "INBOX.VIEW",
  INBOX_CHAT_VIEW: "INBOX.CHAT.VIEW",
  INBOX_CHAT_ASSIGN: "INBOX.CHAT.ASSIGN",

  SUPER_ADMIN_WORKSPACE_VIEW: "SUPER.ADMIN.WORKSPACE.VIEW",
  SUPER_ADMIN_NEW_BUSINESS_APPROVAL: "SUPER.ADMIN.NEW.BUSINESS.APPROVAL",
  SUPER_ADMIN_PLAN_MANAGER_VIEW: "SUPER.ADMIN.PLAN.MANAGER.VIEW",
  SUPER_ADMIN_PRICING_MANAGEMENT_VIEW:
    "SUPER.ADMIN.PRICING.MANAGEMENT.VIEW",
  SUPER_ADMIN_META_RATE_CARD_MANAGEMENT_VIEW:
    "SUPER.ADMIN.META.RATE_CARD.MANAGEMENT.VIEW",
  SUPER_ADMIN_PLAN_PERMISSIONS_LIST: "SUPER.ADMIN.PLAN.PERMISSIONS.LIST",
  SUPER_ADMIN_PERMISSION_CATALOG_VIEW: "SUPER.ADMIN.PERMISSION.CATALOG.VIEW",
  SUPER_ADMIN_ESU_DEBUG: "SUPER.ADMIN.ESU.DEBUG",
  SUPER_ADMIN_SIGNUP_REPORT_VIEW: "SUPER.ADMIN.SIGNUP.REPORT.VIEW",
  SUPER_ADMIN_ACCOUNT_INSIGHTS_FUNNELS_VIEW:
    "SUPER.ADMIN.ACCOUNT.INSIGHTS.FUNNELS.VIEW",
  SUPER_ADMIN_ACCOUNT_INSIGHTS_ALERTS_VIEW:
    "SUPER.ADMIN.ACCOUNT.INSIGHTS.ALERTS.VIEW",
  SUPER_ADMIN_BUSINESS_OVERVIEW: "SUPER.ADMIN.BUSINESS.OVERVIEW",
  SUPER_ADMIN_ACCOUNT_REPORTS_ACCOUNTS_MASTER_VIEW:
    "SUPER.ADMIN.ACCOUNT.REPORTS.ACCOUNTS_MASTER.VIEW",
  SUPER_ADMIN_ACCOUNT_REPORTS_LIFECYCLE_VIEW:
    "SUPER.ADMIN.ACCOUNT.REPORTS.LIFECYCLE.VIEW",
  SUPER_ADMIN_ACCOUNT_REPORTS_TRIALS_VIEW:
    "SUPER.ADMIN.ACCOUNT.REPORTS.TRIALS.VIEW",
  SUPER_ADMIN_ACCOUNT_REPORTS_RISK_VIEW:
    "SUPER.ADMIN.ACCOUNT.REPORTS.RISK.VIEW",
  SUPER_ADMIN_WEBHOOK_MONITOR: "SUPER.ADMIN.WEBHOOK.MONITOR",
  SUPER_ADMIN_WEBHOOK_FAILEDLOG_VIEW: "SUPER.ADMIN.WEBHOOK.FAILEDLOG.VIEW",
  SUPER_ADMIN_USER_MANAGEMENT_VIEW: "SUPER.ADMIN.USER.MANAGEMENT.VIEW",
  SUPER_ADMIN_PRODUCT_GUIDANCE_MANAGE:
    "SUPER.ADMIN.PRODUCT.GUIDANCE.MANAGE",
  ADMIN_WALLET_CREDIT: "ADMIN.WALLET.CREDIT",
  ADMIN_WALLET_DEBIT: "ADMIN.WALLET.DEBIT",
  ADMIN_BUSINESS_BILLING_MODE_MANAGE: "ADMIN.BUSINESS.BILLING_MODE.MANAGE",
  SUPER_ADMIN_FLOW_EXECUTION_EXPLORER_VIEW:
    "SUPER.ADMIN.FLOW.EXECUTION.EXPLORER.VIEW",
  SUPER_ADMIN_DEVELOPER_NOTES_VIEW: "SUPER.ADMIN.DEVELOPER.NOTES.VIEW",
  SUPER_ADMIN_SIGNUP_OTP_CONFIG_VIEW: "SUPER.ADMIN.SIGNUP.OTP.CONFIG.VIEW",
  PLATFORM_BUSINESS_CREATE_VIEW: "PLATFORM.BUSINESS.CREATE.VIEW",
  PLATFORM_PARTNER_CREATE_VIEW: "PLATFORM.PARTNER.CREATE.VIEW",
  PLATFORM_RESELLER_CREATE_VIEW: "PLATFORM.RESELLER.CREATE.VIEW",

  SETTINGS_WORKSPACE_VIEW: "SETTINGS.WORKSPACE.VIEW",
  SETTINGS_WHATSAPP_SETTINGS_VIEW: "SETTINGS.WHATSAPP.SETTINGS.VIEW",
  SETTINGS_THEME_UPDATE: "SETTINGS.THEME.UPDATE",
  SETTINGS_PASSWORD_UPDATE: "SETTINGS.PASSWORD.UPDATE",
  SETTINGS_INTEGRATIONS_VIEW: "SETTINGS.INTEGRATIONS.VIEW",
  SETTINGS_WEBSITE_WIDGET_VIEW: "SETTINGS.WEBSITE.WIDGET.VIEW",
  SETTINGS_CHECKOUT_VIEW: "SETTINGS.CHECKOUT.VIEW",
  SETTINGS_CONTACT_CONSENT_DEBUG: "SETTINGS.CONTACT.CONSENT.DEBUG",
  SETTINGS_PROFILE_VIEW: "SETTINGS.PROFILE.VIEW",
  SETTINGS_META_ACCOUNT_MANAGEMENT: "SETTINGS.META.ACCOUNT.MANAGEMENT",
  SETTINGS_BILLING_VIEW: "SETTINGS.BILLING.VIEW",
  SETTINGS_BILLING_USAGE_VIEW: "SETTINGS.BILLING.USAGE.VIEW",
  SETTINGS_BUSINESS_PRICING_VIEW: "SETTINGS.BUSINESS.PRICING.VIEW",
  SETTINGS_PARTNER_PRICING_VIEW: "SETTINGS.PARTNER.PRICING.VIEW",
  SETTINGS_RESELLER_PRICING_VIEW: "SETTINGS.RESELLER.PRICING.VIEW",
  SETTINGS_WALLET_VIEW: "SETTINGS.WALLET.VIEW",
  SETTINGS_PROFILE_UPDATE: "SETTINGS.PROFILE.UPDATE",
  SETTINGS_ROLE_PERMISSIONS_MAPPING: "SETTINGS.ROLE.PERMISSIONS.MAPPING",
  SETTINGS_STAFF_MANAGEMENT: "SETTINGS.STAFF.MANAGEMENT",
  SETTINGS_TEAM_STAFF_MANAGEMENT: "SETTINGS.STAFF.MANAGEMENT",

  CUSTOMFIELDS_VIEW: "CRM.ATTRIBUTE.VIEW",
  CUSTOMFIELDS_MANAGE: "CRM.ATTRIBUTE.VIEW",

  TEMPLATE_WORKSPACE_VIEW: "TEMPLATE.WORKSPACE.VIEW",
  TEMPLATE_BUILDER_VIEW: "TEMPLATE.BUILDER.VIEW",
  TEMPLATE_BUILDER_CREATE_DRAFT: "TEMPLATE.BUILDER.CREATE.DRAFT",
  TEMPLATE_BUILDER_DRAFT_EDITOR_VIEW: "TEMPLATE.BUILDER.DRAFT.EDITOR.VIEW",
  TEMPLATE_BUILDER_APPROVED_TEMPLATES_VIEW:
    "TEMPLATE.BUILDER.APPROVED.TEMPLATES.VIEW",
  TEMPLATE_BUILDER_PENDING_TEMPLATES_VIEW:
    "TEMPLATE.BUILDER.PENDING.TEMPLATES.VIEW",
  TEMPLATE_BUILDER_LIBRARY_BROWSE: "TEMPLATE.BUILDER.LIBRARY.BROWSE",
};
